import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { authenticationService } from "../api";

const PrivateRoute = ({ admin }) => {
	const location = useLocation();
	const currentUser = authenticationService.currentUserValue;

	if (!currentUser) {
		// Si no está autenticado, redirige a /login
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (admin && !currentUser.user.is_staff) {
		// Si se requiere acceso de administrador y el usuario no lo es, redirige a Home
		return <Navigate to="/" state={{ from: location }} replace />;
	}

	// Si está autenticado (y cumple con permisos, de ser necesario), renderiza las rutas hijas
	return <Outlet />;
};

export default PrivateRoute;
